import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import * as React from 'react';
/**
 * IHeartRadio icon.
 */
const IHeartRadio = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    viewBox="0 0 40 29"
    {...props}
    className={cn('w-full', props.className)}
  >
    <path
      d="M10.67 0C4.776 0 0 4.776 0 10.67c0 3.739 2.368 6.435 4.842 8.93l9.674 9.146a.795.795 0 0 0 1.341-.578v-7.125a3.737 3.737 0 0 1 3.731-3.737 3.738 3.738 0 0 1 3.731 3.737v7.125a.795.795 0 0 0 1.341.578l9.673-9.146c2.474-2.495 4.843-5.191 4.843-8.93C39.176 4.776 34.401 0 28.506 0h-.001c-3.698 0-7.003 1.96-8.917 4.822C17.674 1.96 14.37 0 10.67 0ZM8.12 3.256a.74.74 0 0 1 .368 1.366c-1.657 1.039-2.954 3.473-2.954 5.542v.036c0 2.548 1.448 5.123 4.304 7.653a.739.739 0 1 1-.98 1.108C5.672 16.137 4.056 13.19 4.056 10.2v-.036c0-2.569 1.568-5.491 3.646-6.795a.741.741 0 0 1 .418-.113Zm22.936 0a.74.74 0 0 1 .418.113c2.078 1.304 3.646 4.226 3.646 6.795v.036c0 2.99-1.616 5.937-4.802 8.761a.739.739 0 1 1-.98-1.108c2.855-2.53 4.303-5.105 4.303-7.653v-.036c0-2.069-1.297-4.504-2.954-5.543a.737.737 0 0 1-.232-1.018.738.738 0 0 1 .601-.347Zm-17.549 1.89a.74.74 0 0 1 .406 1.391 4.49 4.49 0 0 0-2.407 3.971c.004 1.818 1.156 3.681 2.867 4.64a.74.74 0 1 1-.722 1.29c-2.16-1.209-3.614-3.585-3.623-5.918v-.022a5.962 5.962 0 0 1 3.197-5.269.744.744 0 0 1 .282-.083Zm12.162 0a.744.744 0 0 1 .282.083 5.964 5.964 0 0 1 3.197 5.269v.022c-.009 2.333-1.463 4.709-3.623 5.918a.74.74 0 0 1-1.008-.284.74.74 0 0 1 .285-1.006c1.712-.959 2.862-2.822 2.867-4.64a4.49 4.49 0 0 0-2.406-3.971.738.738 0 0 1 .406-1.391Zm-6.081 2.702a3.209 3.209 0 0 1 0 6.418 3.208 3.208 0 0 1 0-6.418Z"
      style={{
        fill: '#c6002b',
        fillRule: 'nonzero',
      }}
    />
  </svg>
);

export default IHeartRadio;
